import { styled } from "@mui/material/styles";
import  Button  from "@mui/material/Button";

export const TabButton = styled(Button)((props)=>({
    background: 'none',
    color: props.active ? '#026DF2' : '#666667',
 }));